import { NewModal } from 'lib/components';
import React from 'react';
import { ILandingPageDesignGroup } from '../types';
import { Flex, Gap } from 'lib/components/styles/layout';
import { Button } from 'react-covideo-common';
import { useDeleteGroupMutation } from 'lib/api/superadmin/landingPageDesignGroups/useDeleteGroupMutation';

type DeleteGroupProps = {
  group: ILandingPageDesignGroup;
  onClose: () => void;
};

const DeleteGroupModal = ({ group, onClose }: DeleteGroupProps) => {
  const { mutateAsync: deleteGroup, isLoading: isDeleting } =
    useDeleteGroupMutation(
      {
        groupId: group.landingPageDesignGroupId,
        shouldShowNotifications: true,
      },
      onClose
    );

  const onDelete = async () => {
    await deleteGroup();
  };

  return (
    <NewModal
      headerText={`Are you sure you want to delete "${group.title}"?`}
      closeModal={onClose}
    >
      <Flex gap='20px'>
        <div>{`${group.title} will be permanently deleted.`}</div>
        <Gap gap='8px' justifyContent='flex-end'>
          <Button
            text='Cancel'
            onClick={onClose}
            variant='secondary'
            disabled={isDeleting}
          />
          <Button
            text='Delete'
            onClick={onDelete}
            variant='destructive'
            disabled={isDeleting}
          />
        </Gap>
      </Flex>
    </NewModal>
  );
};

export default DeleteGroupModal;
